/* =========================================================
   Catálogo de productos (47). Claude Code, 2026-09-16.
   Fuente: nota "🗂️ Catálogo ordenado - Productos" (precios de la
   tabla maestra, calculadora Master Escala). Si cambia un producto,
   actualizar tabla maestra, nota, Excel y este archivo.
   - desc: texto para la TIENDA, reescrito sin promesas de tratar,
     curar, adelgazar ni testosterona. No es la columna "para qué
     sirve" de la nota (esa es interna).
   - img: los 6 frascos de ${AS_A}img- + las fotos de Dropi de DROPI_FOTOS
     (2026-09-17). El resto muestra un marcador hasta tener fotos.
   - kit: página de kit que ya existe (energia | mujer).
   Se usa en index.html (vista corta) y en productos.html (completa).
   ========================================================= */
const CATS = [
  { id: 'energia', name: 'Energía y rendimiento', ic: 'bolt', c: '#0E0E0E' },
  { id: 'mujer', name: 'Mujer', ic: 'heart', c: '#6B2D5C' },
  { id: 'descanso', name: 'Sueño y estrés', ic: 'moon', c: '#1E2A5A' },
  { id: 'metabolismo', name: 'Metabolismo', ic: 'flame', c: '#138A8A' },
  { id: 'longevidad', name: 'Longevidad', ic: 'hourglass', c: '#0F5C4D' },
  { id: 'digestion', name: 'Hígado y digestión', ic: 'leaf', c: '#5A8F3D' },
  { id: 'articulaciones', name: 'Articulaciones y huesos', ic: 'move', c: '#2F6690' },
  { id: 'belleza', name: 'Belleza', ic: 'sparkle', c: '#A34A6A' },
  { id: 'bienestar', name: 'Hombre 40+ y bienestar', ic: 'user', c: '#4A4136' },
];

/* Fotos reales de Dropi (foto principal del proveedor), revisadas una por una
   contra el nombre y la etiqueta (Claude Code, 2026-09-17). Están en
   ${AS_A}img-productos-ID.jpg (800x800). SON DE EJEMPLO: sirven para saber qué
   producto es; las fotos definitivas se hacen después (Jacsson, 2026-09-17).
   Se usan todas, incluidas las con logo "DROPI CUP", afiches o collages.
   No hay foto de: 104102 (letrero "PRIVADO"), por decisión de Jacsson.
   [2026-09-18 20:15] 23482, 50838, 72697, 72944, 72945 y 103967 ya tienen foto: las
   bajó Jacsson de Dropi con su sesión y las limpió con ChatGPT. Se identificó cada
   una por la etiqueta del envase, porque venían nombradas "nueva 1", "nueva 2"...
   [anterior] no había foto de 50838 (borrosa) ni de 23482, 103967, 72945, 72697 y
   72944 (sin foto sin sesión en Dropi).
   Observaciones de cada foto: nota "📸 Fotos de productos - Dropi". */
/* [anterior: Claude Code, 2026-09-17 01:20] la lista no incluía 91096, 84659, 95120,
   35868, 58061, 57201, 96544, 96539, 97987 ni 108617 (descartadas por logo, afiche,
   collage o por no coincidir). */
// 125747, 83439, 64268 y 126340 también tienen foto en ${AS_A}img- (3:4, la usan los kits);
// en el catálogo se usa la versión cuadrada para que no se corte la tapa.
const DROPI_FOTOS = [125747, 83439, 64268, 126340, 125745, 125749, 158579, 37301, 46242, 48056, 49208, 54685, 54979, 59438, 61032, 63663, 63664,
  64269, 65555, 67632, 72695, 72696, 84072, 87268, 89150, 91095, 91660, 96342, 96541, 97448,
  91096, 84659, 95120, 35868, 58061, 57201, 96544, 96539, 97987, 108617,
  // [2026-09-18 20:15] fotos nuevas de Jacsson, ya limpias de origen:
  23482, 50838, 72697, 72944, 72945, 103967];

/* Productos APARTADOS: están en los datos, pero NO se muestran en la tienda (Jacsson, 2026-09-17).
   104102: foto "PRIVADO", hay que pagar para acceder. 97987: la etiqueta no dice shilajit.
   108617: la foto de Dropi es otra creatina; hay que investigarlo. */
const APARTADOS = [104102, 97987, 108617];

/* Fotos limpias sobre fondo blanco (1200x1200 + webp). Las limpió Jacsson con ChatGPT
   desde las fotos reales de Dropi y se revisaron una por una contra la etiqueta original
   (2026-09-18). La versión anterior de cada una está en ${AS_A}img-productos-_anteriores/.
   54685 y 83439 se rechazaron primero porque ChatGPT cambió la etiqueta (810MG->600MG y ("MAXIMUN"->"MAXIMUM", "160 Greamos"
   "MAXIMUN"->"MAXIMUM", "160 Greamos"->"150 Gummies"). Las dos volvieron corregidas
   y verificadas con zoom contra la etiqueta original: 83439 el 2026-09-18 20:15 y
   54685 el 2026-09-18 21:35 (ya dice 810MG | 30 CAPS). Ahora están todas limpias.
   Detalle en la nota "📸 Fotos de productos - Dropi". */
const LIMPIAS = [35868, 37301, 46242, 49208, 57201, 58061, 61032, 64268, 64269, 65555, 67632, 84072,
  84659, 91095, 91096, 95120, 96539, 96541, 96544, 125745, 125747, 125749, 158579,
  // [2026-09-18 20:15] las 7 nuevas (6 productos que no tenían foto + 83439 corregida):
  23482, 50838, 54685, 72697, 72944, 72945, 83439, 103967];

// [id Dropi, nombre, descripción corta, categoría, sexo H|M|A, precio 1 u, img, kit, destacado]
/* [2026-09-20] 23482 pasó de "Menopausia Winner" a "Menopax Plus": la etiqueta del
   frasco dice MENOPAX PLUS. Era un pendiente por confirmar y se resolvió al leer la
   foto para armar su ficha. El nombre de la tienda tiene que ser el del envase que
   recibe el cliente. */
/* ⚠️ PRECIOS DE 1 UNIDAD, subidos $5.000 el 2026-09-20 (decisión de Jacsson).
   [anterior] la mayoría estaba en $39.900 y algunos en $44.900.
   El motivo era absorber un descuento de bienvenida de 10/20/30% al azar. Ese
   juego sigue dando 10/20/30%, pero ahora el % se descuenta SOLO DE LA SEGUNDA
   UNIDAD y no aplica en los 8 productos del hero (ver SIN_PREMIO, más abajo).
   La subida se mantiene: es el margen que hace que eso cuadre.
   El porqué del cambio está en el bloque del juego, en app.js, y en la bitácora
   del 2026-09-20. Si se toca un precio de aquí, rehacer ese cálculo. */
const PRODUCTS = [
  // Energía y rendimiento
  [104102, 'Shilajit + Turkesterona', 'Dos clásicos de la rutina masculina en un solo pedido.', 'energia', 'H', 49900],
  [97987, 'Shilajit Ultra', 'Shilajit para acompañar tu energía del día.', 'energia', 'H', 44900],
  [125747, 'NAD+ para hombres (Selerb)', 'NAD+ para tu rutina de energía con los años.', 'energia', 'H', 44900, 'nad', 'energia', 1],
  [63663, 'Óxido nítrico 1000 mg', 'Para tu rutina de entrenamiento.', 'energia', 'H', 44900],
  [48056, 'Creatina monohidratada 300 g', 'La creatina de siempre, para entrenar con fuerza.', 'energia', 'H', 49900],
  [83439, 'Gomitas de shilajit', 'Shilajit en gomitas, fácil de llevar a todos lados.', 'energia', 'H', 44900, 'shilajit', 'energia', 1],
  [91096, 'Turkesterona (Old School)', 'Para acompañar tu entrenamiento de fuerza.', 'energia', 'H', 44900, 'turkesterona', 'energia', 1],
  // Mujer
  [49208, 'Curvy Gummies', 'Gomitas de aguaje para tu rutina diaria.', 'mujer', 'M', 44900],
  [64268, 'Creatina para mujer', 'Creatina pensada para mujeres que entrenan.', 'mujer', 'M', 44900, 'creatina', 'mujer', 1],
  [108617, 'Creatina + colágeno + BCAA', 'Tres en uno para entrenar y recuperarte.', 'mujer', 'M', 44900],
  [23482, 'Menopax Plus', 'Un apoyo para tu rutina en esta etapa.', 'mujer', 'M', 49900],
  [64269, 'Probiótico íntimo femenino', 'Probiótico para tu bienestar íntimo.', 'mujer', 'M', 44900],
  // Sueño y estrés
  [103967, 'Sleep Zen', 'Para tu rutina de descanso por la noche.', 'descanso', 'A', 49900],
  /* [anterior 2026-09-19] decía "12 tipos de magnesio": el frasco se llama 12-in-1,
     pero la etiqueta aclara "6 TIPOS DE MAGNESIO ACTIVOS" y lista seis. */
  [126340, 'Magnesio 12 en 1', '6 tipos de magnesio, 720 mg por porción, para relajarte y descansar.', 'descanso', 'A', 44900, 'magnesio', 'mujer', 1],
  [54979, 'Ashwagandha + magnesio', 'Para los días con mucho estrés.', 'descanso', 'A', 44900],
  [96342, 'MagneCalm Pro', 'Para relajarte después de un día intenso.', 'descanso', 'A', 49900],
  [91095, 'Rest Sleep Drops', 'Gotas para tu rutina antes de dormir.', 'descanso', 'A', 44900],
  [61032, 'Ashwagandha 1000 mg', 'Para manejar el estrés del día a día.', 'descanso', 'A', 44900],
  // Metabolismo
  [95120, 'Lemme Burn', 'Para acompañar tu metabolismo.', 'metabolismo', 'M', 44900],
  [91660, 'Gomitas de vinagre de manzana', 'Vinagre de manzana en gomitas, sin el sabor fuerte.', 'metabolismo', 'A', 44900],
  [125745, 'Berberina', 'Para acompañar tu metabolismo y tu alimentación.', 'metabolismo', 'A', 44900],
  [72945, 'Balloon Slim', 'Para acompañar tu control del apetito.', 'metabolismo', 'A', 49900],
  [158579, 'Drenaje linfático Aurelys', 'Para cuando te sientes con hinchazón.', 'metabolismo', 'A', 44900],
  // Longevidad
  [58061, 'Tripack NAD + ashwagandha + cándida', 'Pack de 3 frascos: energía, estrés y flora intestinal.', 'longevidad', 'A', 59900],
  [87268, 'Pack x3 NAD+ resveratrol', 'Pack de 3 frascos para envejecer mejor.', 'longevidad', 'A', 59900],
  [54685, 'NAD Life Extension', 'NAD+ para tu energía con los años.', 'longevidad', 'A', 44900],
  [46242, 'Resveratrol 590 mg', 'Antioxidante para tu rutina de longevidad.', 'longevidad', 'A', 44900],
  // Hígado y digestión
  [72697, 'Liver Complex', 'Para cuidar tu hígado.', 'digestion', 'A', 49900],
  [96544, 'Hepa Health', 'Para cuidar tu hígado.', 'digestion', 'A', 44900],
  [57201, 'Limpieza de colon 15 días', 'Rutina de 15 días para tu digestión.', 'digestion', 'A', 44900],
  [37301, 'Candida Cleanse', 'Para el equilibrio de tu flora intestinal.', 'digestion', 'A', 44900],
  [50838, "Gomitas de fibra Physician's Choice", 'Fibra en gomitas para tu digestión.', 'digestion', 'A', 44900],
  [35868, '15 Day Cleanse', 'Rutina de 15 días para tu digestión.', 'digestion', 'A', 44900],
  [84072, 'Aceite de orégano', 'Para tu digestión y tus defensas.', 'digestion', 'A', 39900],
  // Articulaciones y huesos
  [67632, 'Cúrcuma (Turmeric Curcumin)', 'Para cuidar tus articulaciones.', 'articulaciones', 'A', 44900],
  [97448, 'OsteoRegen', 'Para cuidar tus huesos.', 'articulaciones', 'A', 49900],
  [96539, 'Osteomax', 'Vitaminas y minerales para tus huesos.', 'articulaciones', 'A', 44900],
  [125749, 'Joint Health', 'Para moverte con soltura.', 'articulaciones', 'A', 44900],
  // Belleza
  [84659, 'Colágeno en péptidos', 'Para tu piel, pelo, uñas y articulaciones.', 'belleza', 'A', 44900, 'colageno', 'mujer', 1],
  [96541, 'Colágeno + biotina (Golden Prod)', 'Para tu piel, pelo y uñas.', 'belleza', 'A', 49900],
  [63664, 'Biotina + colágeno 1000 mg', 'Para tu piel, pelo y uñas.', 'belleza', 'A', 44900],
  [72944, 'Colageterna', 'Colágeno para tu piel y articulaciones.', 'belleza', 'A', 49900],
  // Hombre 40+ y bienestar
  [72695, 'Prostaphytol', 'Para el cuidado masculino después de los 40.', 'bienestar', 'H', 49900],
  [65555, 'Hallprost Ultra', 'Para el cuidado masculino después de los 40.', 'bienestar', 'H', 44900],
  [59438, 'Melena de león', 'Para tu concentración en el día.', 'bienestar', 'A', 44900],
  [72696, 'AudioCalm', 'Para tu bienestar auditivo.', 'bienestar', 'A', 49900],
  [89150, 'Veinophytol Pro', 'Para cuando sientes las piernas cansadas.', 'bienestar', 'A', 49900],
].map(([id, name, desc, cat, sex, price, img = '', kit = '', top = 0]) => ({ id, name, desc, cat, sex, price, img: DROPI_FOTOS.includes(id) ? `productos/${id}` : img, kit, top }));

/* Precios de los packs: id -> [2 unidades, 3 unidades].
   Salen de las columnas "2 u" y "3 u" de la tabla maestra
   `📦 Productos - Tienda de suplementos`, y cada unidad extra vale lo que dice
   el sello del banner ("el 2º por $8.990"). Si se cambia uno, cambiarlo también
   en la tabla y revisar que el sello del banner siga cuadrando.
   ⚠️ Los packs YA SON UNA OFERTA: no reciben el descuento de bienvenida. */
/* Los 8 productos que salen en los banners del hero NO reciben el descuento del
   juego de bienvenida (Jacsson, 2026-09-20). Su sello ya promete "el 2º por
   $8.990" y no se puede prometer dos cosas distintas sobre el mismo frasco: el
   cliente vería un precio en la portada y otro en la tarjeta.
   ⚠️ Si un producto entra o sale del hero (HERO_BANNERS, en app.js), hay que
   moverlo también aquí. */
/* [2026-09-30] Entra 65555 (Hallprost Ultra): es la oferta nueva de Halloween
   y su sello promete el 2º por $9.000. */
const SIN_PREMIO = [125749, 54685, 125747, 84659, 126340, 96544, 103967, 72697, 65555, 49208];

const PACKS = {
  23482: [62900, 75900],
  35868: [44900, 60900],
  37301: [52900, 60900],
  46242: [52900, 60900],
  48056: [61900, 73900],
  /* [2026-10-02] 2x1: dos frascos al precio de uno. El banner lo promete y la
     ficha tiene que cobrarlo, si no el cliente ve un precio y paga otro.
     Costeado: dos unidades a $44.900 dejan $7.806 (los costos fijos del pedido
     —flete con devoluciones + anuncio— se pagan UNA vez, no por frasco). */
  49208: [44900, 62900],
  50838: [55900, 66900],
  54685: [53890, 62880],
  54979: [54900, 64900],
  57201: [54900, 64900],
  58061: [84900, 109900],
  59438: [54900, 64900],
  61032: [54900, 64900],
  63663: [54900, 64900],
  63664: [54900, 64900],
  64268: [53900, 62900],
  64269: [51900, 58900],
  /* [2026-10-03] EL 2x1 DE VERDAD. Los cinco banners del CyberMonday llevan
     "2x1 · EL 2º GRATIS · $89.800 → $44.900" pintado DENTRO de la foto, pero la
     ficha cobraba $52.900 a $54.900 por dos: la tienda prometía algo que no
     cumplía. Se detectó al hacer que el banner llevara directo a la ficha —
     antes el catálogo de por medio disimulaba la contradicción.
     Jacsson eligió bajar el precio en vez de rehacer las 10 imágenes.
     Solo cambia el precio de 2 unidades (pasa a ser el de 1, que es lo que
     significa 2x1). El de 3 queda igual, así el tercero cuesta lo mismo que
     antes. Los costos fijos son $27.094 por PEDIDO, no por frasco: el segundo
     frasco no los vuelve a pagar, y por eso regalarlo se sostiene. */
  65555: [44900, 62900],
  67632: [44900, 64900],
  72695: [63900, 77900],
  72696: [62900, 75900],
  72697: [64900, 79900],
  72944: [61900, 73900],
  72945: [64900, 79900],
  83439: [44900, 62900],
  84072: [45900, 51900],
  84659: [53890, 62880],
  87268: [80900, 101900],
  89150: [62900, 75900],
  91095: [53900, 62900],
  91096: [52900, 60900],
  91660: [54900, 64900],
  95120: [53900, 62900],
  96342: [61900, 73900],
  96539: [55900, 66900],
  96541: [61900, 73900],
  96544: [57800, 70700],
  97448: [62900, 75900],
  97987: [53900, 62900],
  103967: [63900, 77900],
  104102: [65900, 81900],
  108617: [53900, 62900],
  125745: [54900, 64900],
  125747: [53890, 62880],
  125749: [53890, 62880],
  126340: [54900, 64900],
  158579: [44900, 64900]
};


/* ═══ PRECIOS DEL CYBERMONDAY ════════════════════════════════════════════════
   [2026-10-03] Jacsson: *"aplicar los porcentajes de descuento a todos los
   productos que se pueda aplicar y el 2x1 a todos los que se pueda… ver la
   información de los proveedores para ver si se pueden aplicar"*.

   Calculado producto por producto con el modelo de Master Escala (costo de la
   tabla maestra, flete $6.500 ÷ 65% de entrega = $10.000, anuncio $10.000 ÷
   58,5% de efectividad = $17.094, todo por PEDIDO):
     · 2x1 (2 u. al precio de 1, la 3ª a $18.000) donde deja al menos $3.000
       con anuncio a $10.000 y no pierde aunque el anuncio suba a $12.500.
       → 34 productos.
     · Donde el 2x1 no cabe, el mayor % redondo sobre el pack de 2 (máx. 45%)
       con las mismas dos condiciones. → 13 productos (35% a 45%).
   Ninguno queda en rojo. Detalle en la bitácora del 2026-10-03.

   SOLO MIENTRAS DURA LA CAMPAÑA "cyber" (alargada hasta el 10 oct 23:59). El 11 de
   octubre `CAMPANA` cambia y vuelven solos los PACKS de arriba: no hay que
   tocar nada. Si se quiere repetir en Black Friday, cambiar la condición. */
const PACKS_CYBER = {
  23482: [53900, 73900],
  35868: [44900, 62900],
  37301: [44900, 62900],
  46242: [44900, 62900],
  48056: [49900, 67900],
  49208: [44900, 62900],
  50838: [48900, 66900],
  54685: [44900, 62900],
  54979: [44900, 62900],
  57201: [48900, 66900],
  58061: [76900, 97900],
  59438: [44900, 62900],
  61032: [44900, 62900],
  63663: [44900, 62900],
  63664: [44900, 62900],
  64268: [44900, 62900],
  64269: [44900, 62900],
  65555: [44900, 62900],
  67632: [44900, 62900],
  72695: [53900, 73900],
  72696: [53900, 73900],
  72697: [53900, 73900],
  72944: [49900, 67900],
  72945: [53900, 73900],
  83439: [44900, 62900],
  84072: [39900, 57900],
  84659: [44900, 62900],
  87268: [70900, 88900],
  89150: [53900, 73900],
  91095: [44900, 62900],
  91096: [44900, 62900],
  91660: [44900, 62900],
  95120: [44900, 62900],
  96342: [49900, 67900],
  96539: [48900, 66900],
  96541: [49900, 67900],
  96544: [48900, 66900],
  97448: [49900, 67900],
  97987: [44900, 62900],
  103967: [49900, 67900],
  104102: [58900, 73900],
  108617: [44900, 62900],
  125745: [44900, 62900],
  125747: [44900, 62900],
  125749: [44900, 62900],
  126340: [44900, 62900],
  158579: [44900, 62900]
};
/* ═══ DESCUENTO EN EL PRIMER FRASCO (Cyber) ══════════════════════════════════
   [2026-10-03] Jacsson: *"sí deberíamos crear esas ofertas en los productos que
   se puedan… que sean números cerrados que terminen en 0 o en 5… algunos
   productos con el 2x1, otros con el % de descuento en la primera unidad"*.

   Con el mismo modelo de arriba, el frasco suelto aguanta como MÁXIMO un 20%
   (el 40% pierde plata en todos: el envío y el anuncio se pagan igual con un
   frasco). Cabe en 10 productos; 35868 y 84659 se quedan con 2x1 porque así
   los venden sus banners y promocionales. Estos 8 cambian el 2x1 por:
       1 u. −20% · 2 u. −40% · 3 u. −45%   (contra el precio normal)
   Con anuncio a $12.500 el que menos deja es Sleep Zen / MagneCalm: $32 en
   1 u. Normal: precio · 2 u · 3 u. El 11 oct vuelven solos los precios. */
const PRIMERO_CYBER = {
  // id:     [1 u.,  2 u.,  3 u.]
  37301:  [35900, 52900, 73900],   // Candida Cleanse
  48056:  [39900, 58900, 81900],   // Creatina monohidratada 300 g
  64269:  [35900, 52900, 73900],   // Probiótico íntimo femenino
  72944:  [39900, 58900, 81900],   // Colageterna
  96342:  [39900, 58900, 81900],   // MagneCalm Pro
  96541:  [39900, 58900, 81900],   // Colágeno + biotina (Golden Prod)
  103967: [39900, 58900, 81900],   // Sleep Zen
  125747: [35900, 52900, 73900],   // NAD+ para hombres (Selerb)
};

/* Todo % que se muestra es "cerrado": múltiplo de 5, hasta 50, y hacia ABAJO
   (si ahorras 53% dice 50%: nunca promete más de lo que es). */
const pctCerrado = (ahorro, base) => Math.min(50, Math.floor(ahorro / base * 20) * 5);

if (typeof CAMPANA !== 'undefined' && CAMPANA.id === 'cyber') {
  Object.assign(PACKS, PACKS_CYBER);
  /* p.normal guarda el precio de siempre: es el "antes" tachado. */
  PRODUCTS.forEach((p) => {
    const pr = PRIMERO_CYBER[p.id];
    if (pr) { p.normal = p.price; p.price = pr[0]; PACKS[p.id] = [pr[1], pr[2]]; }
  });
  /* Con 2x1 el segundo ya es gratis: el premio del juego (un % del 2º) no
     tiene sobre qué aplicarse. Quedan fuera del juego, como los del hero. */
  PRODUCTS.forEach((p) => {
    /* [2026-10-03] los de −20% en 1 u. tampoco: el margen ya se fue en el descuento. */
    /* [2026-10-03, auditoría] De los 10 con "−X% llevando 2", solo estos 2 quedan
       en rojo con el premio máximo (30% del 2º) y anuncio a $12.500: Balloon Slim
       −$668 y Tripack NAD −$1.568. Los otros 8 aguantan (el peor, Prostaphytol,
       deja $332), así que el juego sigue vivo para ellos. */
    const ROJO_CON_PREMIO = [72945, 58061];
    if (PACKS[p.id] && (PACKS[p.id][0] <= p.price || p.normal || ROJO_CON_PREMIO.includes(p.id))
        && !SIN_PREMIO.includes(p.id)) SIN_PREMIO.push(p.id);
  });
}

/* El % de descuento del pack de 2, contra llevar dos sueltas. Lo usan la
   tarjeta del catálogo y la ficha. */
/* [anterior: Claude Code, 2026-10-03] Math.floor((1 - pk[0] / (p.price * 2)) * 100)
   — daba números como 46% y se calculaba sobre el precio ya rebajado. */
function dctoPack(p) {
  const pk = PACKS[p.id];
  const base = (p.normal || p.price) * 2;
  return pk ? pctCerrado(base - pk[0], base) : 0;
}
/* [2026-10-03] 2x1 = el pack de 2 cuesta lo mismo que 1. Sello igual al de los
   banners; lo usan la tarjeta y la foto de la ficha. */
const es2x1 = (p) => !!PACKS[p.id] && PACKS[p.id][0] <= p.price;
const sello2x1 = () => `<span class="sello-2x1" aria-label="2x1: el segundo gratis"><b>2x1</b><i>EL 2º GRATIS</i></span>`;
/* % del frasco suelto (solo los de PRIMERO_CYBER). */
const dctoUno = (p) => (p.normal ? pctCerrado(p.normal - p.price, p.normal) : 0);

const SEX = { H: 'Hombre', M: 'Mujer', A: 'Hombre y mujer' };
const KIT_LINK = { energia: ['kit-energia.html', 'Kit Energía'], mujer: ['kit-mujer.html', 'Kit Mujer Fuerte'] };

/* Las 3 opciones de cantidad. Si el producto no tiene packs, no se muestra nada
   y la tarjeta queda como antes. El ahorro se calcula contra llevar sueltas. */
function packOpciones(p) {
  const pk = PACKS[p.id];
  if (!pk) return '';
  const [dos, tres] = pk;
  /* El extra es lo que cuesta cada unidad adicional: el mismo número que el sello
     del banner ("el 2º por $8.990"). Se prefiere a un "ahorras $35.900", que es
     cierto pero suena inflado y no dice qué está pagando. */
  const extra = dos - p.price;
  /* Con el 2x1 el extra es 0, y "El 2º por $0" se lee como un error. */
  /* [2026-10-03] EL ANTES TACHADO. Jacsson: *"hay que agregarlo sí o sí, ya que
     el precio elevado de $89.800 llama a pensar wow, me estoy ahorrando mucho"*.
     Y tiene razón por un motivo más: un 2x1 SIN precio tachado se lee como
     truco — si dos cuestan lo mismo que uno, el cliente concluye que uno nunca
     valió eso. El tachado es lo que convierte la oferta en un hallazgo.
     El "antes" no es inventado: es el precio unitario de la ficha por n. */
  const antes = (n) => (p.normal || p.price) * n;   // [2026-10-03] normal: con −20% en 1 u.
  const filas = [
    { n: 1, precio: p.price, pie: '' },
    { n: 2, precio: dos, pie: extra <= 0 ? '<b class="pk-2x1">2x1</b> El 2º <b>GRATIS</b>' : `El 2º por ${clp(extra)}` },
    /* Con 2x1 el segundo ya es gratis: decir "2º y 3º a X" se contradice. */
    /* [2026-10-03] Siempre "El 3º por X" con el precio REAL del tercero. Con los
       precios del Cyber el 3º ya no vale lo mismo que el 2º, y "2º y 3º a $4.000"
       mentía (en Prostaphytol el 3º cuesta $20.000).
       [anterior: Claude Code] extra <= 0 ? `El 3º por …` : `2º y 3º a ${extra}` */
    { n: 3, precio: tres, pie: `El 3º por ${clp(tres - dos)}` },
  ].map((f) => ({ ...f, ahorro: antes(f.n) - f.precio }));
  const mejor = 2;   // el de 2 es el que queremos empujar: es el del banner
  return `<div class="p-packs" role="radiogroup" aria-label="¿Cuántos llevas?">
    ${filas.map((f, i) => `
      <button class="p-pack${i === 0 ? ' on' : ''}${f.n === mejor ? ' top' : ''}" type="button"
              role="radio" aria-checked="${i === 0}" data-pack="${f.precio}">
        <span class="p-pack-dot" aria-hidden="true"></span>
        <span class="p-pack-txt">
          <b>${f.n} <span class="u-corta">u.</span><span class="u-larga">${f.n === 1 ? 'unidad' : 'unidades'}</span></b>
          ${f.pie ? `<small>${f.pie}</small>` : ''}
        </span>
        ${f.n === mejor ? '<span class="p-pack-tag">El más pedido</span>' : ''}
        <span class="p-pack-precio">
          ${f.ahorro > 0 ? `<s>${clp(antes(f.n))}</s>` : ''}
          ${clp(f.precio)}
          ${f.ahorro > 0 ? `<em>-${pctCerrado(f.ahorro, antes(f.n))}% · Ahorras ${clp(f.ahorro)}</em>` : ''}
        </span>
      </button>`).join('')}
  </div>`;
}

function productCard(p) {
  const cat = CATS.find((c) => c.id === p.cat);
  // [2026-09-27] si el producto tiene recorte limpio, ese manda sobre la foto del proveedor.
  const media = fotoProducto(p.id, p.name) || (p.img
    // [anterior: Claude Code, conservado 2026-09-18] ? `<img src="${AS_A}img-${p.img}.jpg" alt="${p.name}" width="720" height="960" loading="lazy">`
    // [anterior: Claude Code, conservado 2026-09-18 20:xx] ? `<img src="${AS_A}img-${p.img}.jpg" alt="${p.name}" width="800" height="800" loading="lazy">`
    // Las fotos limpias (LIMPIAS) tienen .webp además del .jpg: se sirve el webp y el jpg queda de respaldo.
    ? (LIMPIAS.includes(p.id)
      ? `<picture><source srcset="${AS_A}img-${p.img}.webp" type="image/webp"><img src="${AS_A}img-${p.img}.jpg" alt="${p.name}" width="1200" height="1200" loading="lazy"></picture>`
      : `<img src="${AS_A}img-${p.img}.jpg" alt="${p.name}" width="800" height="800" loading="lazy">`)
    : `<div class="slot p-slot" style="--pc:${cat.c}">${ic(cat.ic)}</div>`);
  const kit = p.kit ? `<a class="p-kit" href="${KIT_LINK[p.kit][0]}">${ic('gift')}En el ${KIT_LINK[p.kit][1]}</a>` : '';
  /* el id deja que el hero enlace directo a la tarjeta: productos.html#p54685 */
  return `<article class="p-card" id="p${p.id}">
    <div class="p-media"><a href="producto.html?id=${p.id}" aria-label="Ver ${p.name}">${media}</a>
      <!-- [2026-10-03] Jacsson: "hay que destacar más el 2x1". En los 2x1 la
           etiqueta deja de decir "-50%" y pasa a ser el sello de los banners:
           "2x1" grande con la cinta verde "EL 2º GRATIS".
           [anterior: Claude Code] los 2x1 también mostraban "-50%" -->
      ${es2x1(p) ? sello2x1() : dctoUno(p) ? `<span class="p-dcto" aria-label="${dctoUno(p)}% de descuento">-${dctoUno(p)}%</span>`
        : dctoPack(p) >= 30 ? `<span class="p-dcto" aria-label="${dctoPack(p)}% de descuento llevando 2">-${dctoPack(p)}%</span>` : ''}</div>
    <div class="p-body">
      <span class="p-cat" style="--pc:${cat.c}">${ic(cat.ic)}${cat.name}</span>
      <h3><a class="p-link" href="producto.html?id=${p.id}">${p.name}</a></h3>
      <p>${p.desc}</p>
      <div class="p-tags"><span>${SEX[p.sex]}</span>${kit}</div>
      <!-- [anterior 2026-09-20] aquí iba packOpciones(p): las tres opciones de
           cantidad (1, 2 o 3 unidades) con el precio que cambiaba al elegir.
           Jacsson pidió sacarlas del catálogo. La elección sigue existiendo, pero
           en la página del producto, que es donde el cliente decide de verdad;
           aquí queda solo la señal de que llevando 2 sale más barato, que es lo
           que hace clic para entrar. La función packOpciones NO se borró: la
           usa fichas.js en la página del producto. -->
      <!-- [2026-10-03] Con 2x1 decía "El 2º por $0": se leía como un error.
           [anterior: Claude Code] siempre "El 2º por" + el precio del extra -->
      ${PACKS[p.id] ? `<span class="p-2u${es2x1(p) ? ' es-2x1' : ''}">${ic('tag')}${es2x1(p) ? '<b>2x1</b> Lleva 2, paga 1' : p.normal ? `<b>-${dctoPack(p)}%</b> llevando 2` : `El 2º por ${clp(PACKS[p.id][0] - p.price)}`}</span>` : ''}
      <!-- Lo que quedaría con el descuento de bienvenida. Solo se llena si hay uno
           activo; si está elegido un pack, avisa que ya tiene precio de oferta. -->
      <span class="disc-line" data-disc-price="${p.price}" data-unidades="1"
            data-extra="${PACKS[p.id] ? PACKS[p.id][0] - p.price : 0}"${SIN_PREMIO.includes(p.id) ? ' data-sin-premio' : ''}></span>
      <div class="p-foot">
        <span class="p-precios">${p.normal ? `<s>${clp(p.normal)}</s>` : ''}<span class="price" data-precio>${clp(p.price)}</span></span>
        <button class="btn btn-cta p-add" type="button" data-cart aria-label="Agregar ${p.name} al carrito">${ic('cart')}<span>Agregar</span></button>
      </div>
    </div>
  </article>`;
}

/* Arma el catálogo con filtros dentro de `el`.
   opts.preview: cuántos mostrar antes de "Ver todos" (0 = todos). */
function renderCatalog(el, opts = {}) {
  if (!el) return;
  const params = new URLSearchParams(location.search);
  const state = {
    cat: CATS.some((c) => c.id === params.get('cat')) ? params.get('cat') : 'todos',
    sex: ['H', 'M'].includes(params.get('sexo')) ? params.get('sexo') : 'todos',
    sort: 'rec',
    all: !opts.preview,
  };
  const chip = (id, label, icon, color) => `<button type="button" class="cat-chip" data-cat="${id}" style="--pc:${color}">${ic(icon)}<span>${label}</span></button>`;

  el.innerHTML = `
    <div class="cat-filters">
      <div class="cat-row" role="group" aria-label="Filtrar por categoría">
        ${chip('todos', 'Todos', 'box', 'var(--brand)')}
        ${CATS.map((c) => chip(c.id, c.name, c.ic, c.c)).join('')}
      </div>
      <div class="cat-bar">
        <div class="seg" role="group" aria-label="Filtrar por sexo">
          <button type="button" data-sex="todos">Todos</button>
          <button type="button" data-sex="H">Hombre</button>
          <button type="button" data-sex="M">Mujer</button>
        </div>
        <label class="cat-sort">Ordenar
          <select data-sort>
            <option value="rec">Recomendados</option>
            <option value="asc">Menor precio</option>
            <option value="desc">Mayor precio</option>
            <option value="az">Nombre (A–Z)</option>
          </select>
        </label>
      </div>
      <p class="cat-count" aria-live="polite"></p>
    </div>
    <div class="p-grid"></div>
    <div class="cat-more"></div>`;

  const grid = el.querySelector('.p-grid');
  const count = el.querySelector('.cat-count');
  const more = el.querySelector('.cat-more');

  function draw() {
    let list = PRODUCTS.filter((p) => !APARTADOS.includes(p.id) &&
      (state.cat === 'todos' || p.cat === state.cat) &&
      // "Hombre" muestra los de hombre + los de ambos; igual con "Mujer"
      (state.sex === 'todos' || p.sex === state.sex || p.sex === 'A'));
    if (state.sort === 'rec') list = [...list].sort((a, b) => b.top - a.top);
    if (state.sort === 'asc') list = [...list].sort((a, b) => a.price - b.price);
    if (state.sort === 'desc') list = [...list].sort((a, b) => b.price - a.price);
    if (state.sort === 'az') list = [...list].sort((a, b) => a.name.localeCompare(b.name, 'es'));

    const shown = state.all ? list : list.slice(0, opts.preview);
    grid.innerHTML = shown.map(productCard).join('') || '<p class="cat-empty">No hay productos con ese filtro.</p>';
    count.textContent = `${list.length} ${list.length === 1 ? 'producto' : 'productos'}`;
    more.innerHTML = shown.length < list.length
      ? `<button type="button" class="btn btn-ghost" data-more>Ver los ${list.length} productos ${ic('arrow')}</button>`
      : '';

    el.querySelectorAll('[data-cat]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.cat === state.cat));
    el.querySelectorAll('[data-sex]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.sex === state.sex));
  }

  el.addEventListener('click', (e) => {
    const c = e.target.closest('[data-cat]');
    const s = e.target.closest('[data-sex]');
    if (c) state.cat = c.dataset.cat;
    if (s) state.sex = s.dataset.sex;
    if (e.target.closest('[data-more]')) state.all = true;
    if (c || s || e.target.closest('[data-more]')) draw();
  });
  el.querySelector('[data-sort]').addEventListener('change', (e) => { state.sort = e.target.value; draw(); });
  draw();
}
